export default __webpack_public_path__ + "static/plan-your-journey-46aad4bc7cd5757bcabc393ecf574b70.jpg";